import IndecisionApp from "./components/IndecisionApp";
export default IndecisionApp;
